import * as methods from '../methods';
import { Resource } from '../Resource';
import * as transformers from '../transformers';
const rootPath = 'me/notifications';
export var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus[NotificationStatus["read"] = 0] = "read";
    NotificationStatus[NotificationStatus["unread"] = 1] = "unread";
    NotificationStatus[NotificationStatus["deleted"] = 2] = "deleted";
})(NotificationStatus || (NotificationStatus = {}));
export const OrgAdminNotifType = {
    newInvoiceAvailable: 85,
    newInvoice: 86,
    exportData: 84,
    adminAcceptOptionPurchaseRequest: 28,
    adminCallForJoiningNetwork: 2,
    adminCallForJoiningNetworkAsTrial: 3,
    adminDeleteMemberOrganization: 26,
    adminInviteMembership: 12,
    adminInviteNewUserMembership: 23,
    adminRefuseOptionPurchaseRequest: 29,
    convertTrial: 21,
    fewSmsRemaining: 31,
    networkAdminAcceptOrganizationSubscription: 4,
    networkAdminAcceptOrganizationSubscriptionAsTrial: 19,
    networkAdminInviteNewUserSubscription: 24,
    networkAdminInviteNewUserSubscriptionAsTrial: 25,
    networkAdminInviteSubscription: 13,
    networkAdminInviteSubscriptionAsTrial: 14,
    networkAdminRefuseOrganizationSubscription: 16,
    networkAdminRefuseOrganizationSubscriptionAsTrial: 20,
    networkEndTrial: 32,
    networkRemoveSubscriber: 5,
    optionPurchaseRequest: 27,
    organizationAdminAcceptSubscribing: 17,
    organizationAdminAcceptSubscribingAsTrial: 18,
    organizationAdminRefuseSubscribing: 11,
    organizationAdminRefuseSubscribingAsTrial: 1,
    organizationLeaveNetwork: 6,
    userAcceptMembership: 7,
    userAcceptOwnership: 9,
    userLeaveOrganization: 22,
    userRefuseMembership: 8,
    userRefuseOwnership: 10,
    ownerInviteOwnership: 15,
    upgradeOrganizationPremium: 30,
    networkEndTrialIn7Days: 42,
    networkAdvisorCreatePlot: 43,
    networkAdvisorUpdatePlot: 44,
    networkAdvisorPartialUpdatePlot: 45,
    networkAdvisorDestroyPlot: 46,
    networkAdvisorArchivePlot: 48,
    networkAdvisorChangeDevice: 47,
    networkAdvisorActivateOption: 49,
    networkAdvisorDestroyOption: 50,
    upgradeOrganizationExpert: 52,
    networkAdminAcceptOrganizationSubscriptionExpert: 53,
    networkAdminAcceptOrganizationSubscriptionExpertAsTrial: 54,
    networkAdminInviteSubscriptionExpert: 55,
    networkAdminInviteSubscriptionExpertAsTrial: 56,
    networkAdminInviteNewUserSubscriptionExpert: 57,
    networkAdminInviteNewUserSubscriptionExpertAsTrial: 58
};
export const UserAccountNotifType = {
    magicLogin: 51,
    cbExpirationMonth: 33,
    cbExpiration7D: 34,
    licenceExpiration30D: 35,
    downgradeDone: 88,
    downgradeIn7D: 87
};
export const DevicesNotifType = {
    deviceEventLockedSpoon10Events: 63,
    deviceEventLockedSpoon: 64,
    deviceEventNotVertical: 65,
    deviceEventGps: 66,
    deviceEventNoMessages: 67,
    deviceEventNoMessagesEnd: 68
};
export const TipsNotifType = {
    onboardingFreemiumTip1: 36,
    onboardingFreemiumWeephy: 37,
    onboardingFreemiumTip3Viti: 38,
    onboardingFreemiumTip3Culture: 39,
    onboardingFreemiumTip4: 40,
    onboardingFreemiumTip5: 41,
    rainGaugeMaintenanceReminder: 89
};
export const AlertsNotifType = {
    highTemperatureOnSingleMeasurement: 1000,
    lowTemperatureOnSingleMeasurement: 1001,
    highRainfallsOnSingleMeasurement: 1002,
    highHumidityOnSingleMeasurement: 1004,
    lowHumidityOnSingleMeasurement: 1005,
    highWindOnSingleMeasurement: 1006,
    lowWindOnSingleMeasurement: 1007,
    highGustWindOnSingleMeasurement: 1008,
    lowGustWindOnSingleMeasurement: 1009,
    highDryTemperatureOnSingleMeasurement: 1010,
    lowDryTemperatureOnSingleMeasurement: 1011,
    highWetTemperatureOnSingleMeasurement: 1012,
    lowWetTemperatureOnSingleMeasurement: 1013,
    oadRainBeginningAndEnd: 1104,
    highTemperatureOnCumul: 1100,
    highRainfallsOnCumul: 1102,
    rainfallInFollowingPeriod: 1200,
    observedHydricPotentialState: 1301,
    observedSoilMoistureStateCapa: 1302,
    multiPredicatesMeasurement: 59,
    tavmillsContamination: 60,
    highLeafWetnessMeasurement: 61,
    lowLeafWetnessMeasurement: 62,
    tavmillsContaminationLevelChange: 70,
    leafWetnessDurationCumul: 71,
    highRainfallsIntensity: 72,
    leafWetnessBeginEnd: 73
};
export const NotificationType = {
    ...AlertsNotifType,
    ...OrgAdminNotifType,
    ...UserAccountNotifType,
    ...DevicesNotifType,
    ...TipsNotifType
};
export const crossOrgNotifications = [
    NotificationType.adminInviteMembership,
    NotificationType.networkAdminInviteSubscriptionExpert,
    NotificationType.networkAdminInviteSubscriptionExpertAsTrial,
    NotificationType.networkAdminInviteSubscription,
    NotificationType.networkAdminInviteSubscriptionAsTrial
];
const fromRaw = (raw) => ({
    id: raw.id,
    message: raw.message,
    triggeredAt: raw.date,
    type: raw.type,
    networkId: raw.content?.network?.id,
    organizationId: raw.content?.organization?.id,
    link: raw.content?.click_action
});
const notifications = Resource((requesterBuilder) => {
    const getMany = (query) => requesterBuilder({
        path: rootPath,
        requestCtx: {
            transform: transformers.paginatedResponse(fromRaw),
            params: {
                query: {
                    offset: query?.offset,
                    limit: query?.limit,
                    status: query?.status,
                    type: Array.isArray(query?.type) ? query?.type.join(',') : query?.type
                }
            }
        }
    });
    return {
        getMany,
        getPage: methods.getPage({
            getMany
        }),
        getAll: methods.getAllPages({ getMany }),
        markAsRead: methods.deletion({
            rootPath,
            requesterBuilder,
            buildKeysToInvalidate: () => [getMany().invalidationKey]
        }),
        markAllAsRead: () => requesterBuilder({
            path: `${rootPath}/mark_all_as_read`,
            requestCtx: {
                transform: (x) => x,
                parse: async (x) => x,
                method: 'POST'
            },
            keysToInvalidate: [getMany().invalidationKey]
        })
    };
});
export default notifications;
